import { createSelector } from 'reselect'
import { selectAccount } from 'ducks/accounts/selectors/selectAccount'

export const selectAccountSubdomain = createSelector(
  selectAccount,
  account => account.subdomain
)
